import { render } from "./Operator.vue?vue&type=template&id=ef5046e6"
import script from "./Operator.vue?vue&type=script&lang=js"
export * from "./Operator.vue?vue&type=script&lang=js"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__